<amp-engine-tag-value-detail
  [assignmentScope]="scope$ | async"
  [showSiteLabel]="false"
  [editable]="editable$ | async"
  (changeDetails)="changeDetails = $event">
</amp-engine-tag-value-detail>
